import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import routes from "../seoRoutes.json";

// Central per-route SEO. Unknown paths get the 404 treatment (noindex).
// Titles/descriptions live in src/seoRoutes.json, which scripts/prerender.js
// also reads to bake the same tags into each route's static HTML.
function RouteSeo() {
  const path = useLocation().pathname.replace(/\/+$/, "") || "/";
  const meta = routes[path];
  if (!meta) return <Seo title="Page not found" path={path} noindex />;
  const src = meta.canonical ? routes[meta.canonical] || {} : meta;
  return (
    <Seo
      title={src.title}
      description={src.description}
      path={path}
      canonical={meta.canonical}
      noindex={!!meta.noindex}
    />
  );
}

export default RouteSeo;
